export default __webpack_public_path__ + "media/Intune.497de823.svg";